document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.basic-pfaq__item').forEach(function (item) {
    var button = item.querySelector('[data-faq-toggle]');
    if (!button) return;
    button.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      item.closest('.basic-pfaq__list').querySelectorAll('.basic-pfaq__item').forEach(function (other) {
        other.classList.remove('is-open');
      });
      if (!isOpen) {
        item.classList.add('is-open');
      }
    });
  });
});